const typographyFormParamFreq = {
  true: 'Nova Periodicidade',
  false: 'Editar Periodicidade'
};

export default typographyFormParamFreq;
